import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, getVeyaTeamToken } from "../../lib/api";

export default function MerchantAuthGuard({ children }) {
  const location = useLocation();
  const token = getToken();
  const veyaTeamToken = getVeyaTeamToken();

  // ✅ DEV BYPASS via query param
  const params = new URLSearchParams(location.search);
  const devBypass = params.get("dev") === "1";

  // 🚧 Allow access if dev bypass is active
  if (!token && !veyaTeamToken && !devBypass) {
    return (
      <Navigate
        to="/merchant/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}